import styled from 'styled-components'

export const MyDivide = styled.div<{
  space?: number
  dark?: Boolean
}>`
  height: 1px;
  background-color: ${props =>
    props.dark ? props.theme['neutral-300'] : props.theme['neutral-600']};
  margin: ${props => `${props.space || 40}px auto`};
`
